import React from "react";
import styled from "styled-components";

export const Container = styled.div<{
    textAlign?: string;
    enableDarkTheme?: boolean;
}>`
    position: absolute;
    right: 0;
    bottom: 45px;
    min-width: 200px;
    max-width: 70vw;
    max-height: 80vh;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 5px 0;
    text-align: ${(p) => p.textAlign || "center"};
    color: ${(p) => (p.enableDarkTheme ? "#000" : "#fff")};
    background-color: ${(p) => (p.enableDarkTheme ? "#fff" : "#000")};
    border-radius: 4px;
    white-space: nowrap;
`;

const Item = styled.div<{
    justifyContent: string;
    active?: boolean;
    enableDarkTheme?: boolean;
    primary?: boolean;
    padding: string;
}>`
    display: flex;
    flex-wrap: nowrap;
    justify-content: ${(p) => p.justifyContent};
    cursor: ${(p) => {
        return p.active ? "default" : "pointer";
    }};
    user-select: none;
    padding: ${(p) => p.padding};
    border-bottom: 1px solid
        ${(p) => (p.enableDarkTheme ? "#f5f5f5" : "#353839")};
    color: ${(p) => {
        if (p.primary) {
            return "#3e8ede";
        }

        return p.enableDarkTheme ? "#000" : "#f5f5f5";
    }};

    background-color: ${(p) => {
        if (p.active) {
            return p.enableDarkTheme ? "#ebebeb" : "#353839";
        }

        return "transparent";
    }};

    &:last-child {
        border-bottom: 0;
    }

    &:hover {
        background-color: ${(p) => {
            if (p.active) {
                return p.enableDarkTheme ? "#ebebeb" : "#353839";
            }

            return p.enableDarkTheme ? "#f5f5f5" : "#353839";
        }};
    }
`;

type Props = {
    justifyContent?: string;
    active?: boolean;
    enableDarkTheme?: boolean;
    primary?: boolean;
    padding?: string;
    onClick: () => void;
    children: JSX.Element | JSX.Element[];
};

export function MenuItem(props: Props) {
    const {
        primary,
        active,
        justifyContent,
        enableDarkTheme,
        padding,
        onClick,
    } = props;

    return (
        <Item
            active={active}
            primary={primary}
            onClick={onClick}
            justifyContent={justifyContent || "flex-start"}
            padding={padding || "5px 0"}
            enableDarkTheme={enableDarkTheme}
        >
            {props.children}
        </Item>
    );
}
